import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'admin/routes/router';

import {
   fetchDetails,
   fetchNewDetails,
   fetchFilterDetails,
   fetchDetailsById,
   deleteStore,
   initCategoriesOperation,
} from 'admin/state/modules/store/operations';
import {
   setDeleteModal,
   pinOrUnpinBundleItems,
   reorderStore,
   changeInitedState,
   saveStoreScrollPositionAndFilters,
   updateStoreList,
} from 'admin/state/modules/store/actions';
import {
   storeSelector,
   fetchingSelector,
   newFetchingSelector,
   isEmptyByFilterSelector,
   isEmptySelector,
   openDeleteModalSelector,
   isFilterFetchingSelector,
   storeCategoriesSelector,
   isInitedStoreSelector,
   storeScrollPositionAndFiltersSelector,
} from 'admin/state/modules/store/selectors';
import { contentMetaInfoSelector, screenWidthSelector, siteInfoSelector } from 'admin/state/modules/common/selectors';

import Store from 'admin/views/store/index';
import PageLoader from 'common/components/modules/page-loading';
import EmptyState from 'common/components/modules/empty-states';
import PullRefresh from 'admin/utils/PullRefresh.js';
import DeleteModal from 'admin/views/store/modules/delete-confirm';
import { push } from 'connected-react-router';
import './style.css'
import Modal from 'common/components/modules/modal';
import SocialMediaShareLinks from 'common/components/modules/media-share-links'
import toast from 'common/utils/toast';
import emptyStateSvg from 'assets/images/empty-states/store-empty.svg'
import {
   countesStateSelector,
} from 'admin/state/modules/resources/selectors';
import { fetchMediaCountsStateOperation } from 'admin/state/modules/resources/operations';
import QueryParams from 'admin/utils/QueryParams';
import { getPinnedCountStatistics, pinningStoreItems } from 'admin/api/AuthApi';
import ConfirmModal from 'common/components/modules/modal-wrapper';
import CheckboxLabel from 'common/components/elements/inputs/checkbox-label';
import { contentMetaInfo } from 'admin/state/modules/common/actions';
import { changeContentOrders } from 'admin/api/AuthApi';
import { loginAsOperation } from 'admin/state/modules/common/operations';
import { history } from 'admin/state/store';
import Intercom from 'common/utils/Intercom';
import { ARTICLE_ID_ON_STORE } from 'common/utils/intercom-articles';
import cx from 'classnames'
import { moreInfoProps } from 'common/utils/utils';

class StoreContainer extends Component {
   static propTypes = {
      fetchData: PropTypes.func,
      data: PropTypes.object,
      loading: PropTypes.bool,
      loadingNewData: PropTypes.bool,
      isEmpty: PropTypes.bool,
      getNewStore: PropTypes.func,
      isEmptyByFilter: PropTypes.bool,
      getFilterStore: PropTypes.func,
      goTo: PropTypes.func,
      screenWidth: PropTypes.number,
      openDeleteModal: PropTypes.object,
      setDeleteModal: PropTypes.func,
      deleteStore: PropTypes.func,
      isFilterFetching: PropTypes.bool,
      siteInfo: PropTypes.object,
      fetchCountsState: PropTypes.func,
      countesState: PropTypes.object,
      initCategories: PropTypes.func,
      categories: PropTypes.array,
      isInited: PropTypes.bool,
      saveStoreScrollPositionAndFilters: PropTypes.func,
      scrollPositonAndFilters: PropTypes.object,
      pinOrUnpin: PropTypes.func,
      reorderStore: PropTypes.func,
      contentMetaInfo: PropTypes.object,
      updateContentMetaInfo: PropTypes.func,
      loginAs: PropTypes.func,
      changeInitedState: PropTypes.func,
      updateStoreList: PropTypes.func,
      isInsideModal: PropTypes.bool,
      selections: PropTypes.array,
      onSelectItem: PropTypes.func,
      hideScheduledContents: PropTypes.bool,
      hideUnpublishedContents: PropTypes.bool,
   };

   constructor(props) {
      super(props);

      if(!!Object.keys(this.props.scrollPositonAndFilters?.filtersObject)?.length) {
         this.generateUrlQuery(this.props.scrollPositonAndFilters?.filtersObject, false, true)
      }

      let params = QueryParams.getFilters()
      let emptyFilters = !Object.keys(params)?.length
      if(Object.keys(params)?.length === 1 && !!params?.search) {
         emptyFilters = true
      }

      this.state = {
         emptyFilters,
         filterType: Object.keys(params)?.length ? 'search' : '',
         searchValue: 'search' in params ? params?.search : '',
         showLinks: false,
         shareableItemId: null,
         shareableItemType: null,
         locationPath: '',
         isReorderMode: history.location.pathname === '/store/reorder',
         confirmModal: {
            isOpen: false,
         },
         reorderedData: {
            newData: [],
            newIndex: null,
         },
         warningModal: {},
         pinnedCount: {},
      };
      this.paginationCount = 20;
      this.filters = {
         count: this.paginationCount,
         page: 1,
         insideModal: !!props.isInsideModal,
         hideScheduledContents: !!this.props?.hideScheduledContents,
         hideUnpublishedContents: !!this.props?.hideUnpublishedContents,
         status: history.location.pathname === '/store/reorder' ? 'active' : '',
         ...params,
      }
   }


   componentDidMount(){
      const {
         fetchData,
         fetchCountsState,
         initCategories,
         isInited,
         saveStoreScrollPositionAndFilters,
         scrollPositonAndFilters: {
            scrollPosition,
            filtersObject,
         },
         isInsideModal,
      } = this.props

      window.scrollTo(0, scrollPosition)

      if(!!Object.keys(filtersObject)?.length) {
         this.generateUrlQuery(filtersObject, false)
      }
      if(this.state.isReorderMode || !isInited) {
         let param = this.generateQuery()
         fetchData(param, isInsideModal, this.state.isReorderMode)
         fetchCountsState(param);
         initCategories()
         getPinnedCountStatistics('products')
            .then(resp => {
               this.setState({
                  pinnedCount: {
                     ...resp?.data,
                  },
               })
            })
            .catch(err => console.log(err))
      }
      if(isInsideModal){
         let element = document.querySelector('#select-from-stores')
         if(element) element.addEventListener('scroll', this.handleScroll);
      } else {
         window.addEventListener('scroll', this.handleScroll);
      }

      saveStoreScrollPositionAndFilters({ scrollPosition: 0, filters: [], filtersObject: {} })
   }

   componentWillUnmount() {
      const { changeInitedState, isInsideModal } = this.props

      if(isInsideModal){
         let element = document.querySelector('#select-from-stores')
         if(element) element.removeEventListener('scroll', this.handleScroll);
      } else {
         window.removeEventListener('scroll', this.handleScroll);
         changeInitedState(false)
      }
      PullRefresh.destroyAll();
   }

   handleScroll = (e) => {
      const { isInsideModal } = this.props
      const { scrollHeight, clientHeight, scrollTop } = isInsideModal ? e.target : document.documentElement;

      if(scrollHeight - scrollTop - clientHeight < 100) {
         this.nextPage()
      }
   }

   nextPage = async () => {
      const {
         getNewStore,
         loadingNewData,
         data: { current_page: currentPage, last_page: pages },
      } = this.props;
      let query = [];
      if(currentPage < pages && !loadingNewData) {
         this.filters = { ...this.filters, page: currentPage + 1 };
         query = this.generateQuery();
         await getNewStore(query, this.state.isReorderMode);
      } else {
         return
      }
   }

   generateQuery = (onlyCount = false) => {
      const query = [];
      Object.keys(this.filters).forEach((key) => {
         if(this.filters?.[key]) {
            if(onlyCount && key === 'page') return
            !['insideModal', 'sortBy', 'count', 'page', 'hideUnpublishedContents', 'hideScheduledContents'].includes(key) ?
               query.push(`query[]=${ key }=${ encodeURIComponent(this.filters[key]) }`)
               :
               query.push(`${ key }=${ encodeURIComponent(this.filters[key]) }`);
         }
      })

      return query;
   };

   generateUrlQuery = (filters, isReorderMode, withoutUpdateState = false) => {
      const { isInsideModal, saveStoreScrollPositionAndFilters } = this.props

      if(filters && !isInsideModal) {
         const urlParams = {};
         Object.keys(filters).forEach((key) => {
            if(key){
               if(!['insideModal', 'count', 'page', 'hideUnpublishedContents', 'hideScheduledContents'].includes(key)) {
                  urlParams[key] = filters[key]
               }
            }
         });
         QueryParams.defineFilters(urlParams)
      }
      let params = isInsideModal ? filters : QueryParams.getFilters()

      let emptyFilters = true

      Object.keys(params).forEach(key => {
         if(!['insideModal', 'count', 'page', 'hideUnpublishedContents', 'hideScheduledContents'].includes(key) && params[key].length && params[key] !== 'date_added:desc') {
            emptyFilters = false
         }
      })

      if(Object.keys(params)?.length === 1 && !!params?.search) {
         emptyFilters = true
      }

      if(isReorderMode) {
         params = {
            ...params,
            status: 'active',
         }
      }

      this.filters = { count: 20, page: 1, ...params }
      if(isInsideModal) saveStoreScrollPositionAndFilters({ filtersObject: this.filters })

      if(withoutUpdateState) return
      this.setState({
         ...this.state,
         emptyFilters,
         filterType: emptyFilters ? '' : 'search',
         searchValue: 'search' in params ? params?.search : '',
      })
   };

   onFilterChange = async (value, type) => {
      const { getFilterStore, fetchCountsState } = this.props
      const { isReorderMode } = this.state
      let params = {}

      if(!value.length) {
         let { [type]: _, ...newFilters } = this.filters
         params = { ...newFilters }
      } else {
         params = {
            ...this.filters,
            [type]: value,
         }
      }

      this.generateUrlQuery(params, isReorderMode)
      let query = this.generateQuery()

      await getFilterStore(query, this.state.isReorderMode)
      await fetchCountsState(query)
   }

   onClearAllFilters = async () => {
      const { getFilterStore, fetchCountsState, hideScheduledContents, hideUnpublishedContents, isInsideModal } = this.props
      const { isReorderMode } = this.state

      let newFilters = {
         count: this.paginationCount,
         page: 1,
         hideScheduledContents,
         hideUnpublishedContents,
         insideModal: isInsideModal,
      }

      this.generateUrlQuery(newFilters, isReorderMode)
      let params = this.generateQuery()

      await getFilterStore(params, this.state.isReorderMode)
      await fetchCountsState(params)
   }

   openCloseDeleteModal = (isOpen, item) => {
      const { setDeleteModal } = this.props
      setDeleteModal({ item, isOpen })
   }

   onCloseOrOpenWarningModal = (data) => {
      this.setState({ warningModal: data })
   }

   deleteItem = () => {
      const { openDeleteModal, deleteStore, data } = this.props;
      const { name, id } = openDeleteModal.item
      let param = this.generateQuery()
      let product_type = data?.data?.find(item => item.id === id).product_type
      deleteStore(id, name, param, product_type, (data) => {
         this.openCloseDeleteModal(false, null)
         this.onCloseOrOpenWarningModal(data)
      })

   }

   handleCloseModal = () => {
      this.setState((prev) => {
         return {
            ...prev,
            showLinks: !this.state.showLinks,
         }
      })
   }

   onShare = (id, type, prefix) => {
      this.setState((prev) => {
         return {
            ...prev,
            shareableItemId: id,
            shareableItemType: type,
            locationPath: prefix,
         }
      })
   }

   onShareStore = (id, type) => {
      const { locationPath } = this.state
      let text = locationPath
      if(type === 'store'){
         text = `${ locationPath }${ Router.route('STORE_DETAILS').getCompiledPath({ id }) }`
      }
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      toast.info('Sharing link has been copied');
   }

   pinningBundleItem = (id, is_pinned) => {
      const { pinOrUnpin } = this.props
      pinningStoreItems(id).then(res => {
         pinOrUnpin({ id, is_pinned })
         toast.success(`${ res.data.message } `,
            {
               className: 'custom-ams-toast !bg-success custom-ams-toast-container',
            }
         )
      }).catch()
   }

   onSortEnd = async ({ newData, newIndex }, bool = false) => {
      // eslint-disable-next-line no-unused-vars
      const { reorderStore, contentMetaInfo: { dont_show_content_reorder_message_store } } = this.props
      try {
         // if(!bool && !dont_show_content_reorder_message_store) {
         //    this.setState({
         //       confirmModal: {
         //          ...this.state.confirmModal,
         //          isOpen: true,
         //       },
         //       reorderedData: { newData, newIndex },
         //    })
         // } else {
         //    this.setState({
         //       confirmModal: {
         //          ...this.state.confirmModal,
         //          isOpen: false,
         //       },
         //       reorderedData: { newData: [], newIndex: null },
         //    })
         //    let replace_prev_id  = !!newData[newIndex - 1] ? newData[newIndex - 1].id : null
         //    let replaced_id = newData[newIndex].id
         //    let replace_next_id = !!newData[newIndex + 1] ? newData[newIndex + 1].id : null
         //    if(!!replace_next_id && !newData[newIndex + 1].active) {
         //       replace_next_id = null
         //    }
         //    if(!!replace_prev_id && !newData[newIndex - 1].active) {
         //       replace_prev_id = null
         //    }
         //    const { data } = await changeContentOrders('products', { replaced_id, replace_next_id, replace_prev_id, dont_show_message_again: dont_show_content_reorder_message_store })
         //    newData.forEach((item, index) => {
         //       if(item.id === replaced_id) {
         //          newData[index].publish_date = data
         //       }
         //    })
         //    reorderStore(newData)
         //    toast.success('Content has been reordered')
         // }

         const isSortByAsc = this.filters.sortBy === 'date_added:asc'

         const orderedData = newData.map((item, index) => {
            return {
               id: item.id,
               order: !isSortByAsc ? newData.length - index : index + 1,
               name: item?.name,
            };
         })

         this.setState({
            reorderedData: { newData, newIndex },
         })

         await changeContentOrders('products', { data: orderedData })

         reorderStore(newData)
         toast.success('Content has been reordered')
      } catch (error) {
         console.log(error);
      }
   }

   onStatusFilter = (isReorderMode) => {
      const { goTo, changeInitedState } = this.props
      changeInitedState(false)
      let route = history.location.pathname === '/store' ? 'STORE_REORDER' : 'STORE'
      goTo(Router.route(`${ route }`).getCompiledPath())

   }

   onRouteChange = (route_name, isNewTab) => {
      const { goTo } = this.props
      let nextRoute = Router.route(route_name).getCompiledPath()
      if(isNewTab) {
         window.open(nextRoute)
      } else {
         goTo(nextRoute)
      }
   }

   render() {
      const {
         data,
         loading,
         loadingNewData,
         isEmptyByFilter,
         isEmpty,
         screenWidth,
         openDeleteModal,
         isFilterFetching,
         siteInfo,
         countesState,
         categories,
         goTo,
         saveStoreScrollPositionAndFilters,
         contentMetaInfo,
         updateContentMetaInfo,
         loginAs,
         updateStoreList,
         isInsideModal,
         selections,
         onSelectItem,
      } = this.props

      const {
         filterType,
         searchValue,
         showLinks,
         shareableItemId,
         shareableItemType,
         locationPath,
         emptyFilters,
         isReorderMode,
         confirmModal,
         warningModal,
         pinnedCount,
      } = this.state

      return (
         loading ? (
            <PageLoader
               withLoader={ isInsideModal }
               customStyle={ cx({
                  'flex flex-1 h-full': isInsideModal,
               }) }
            />
         ) : (
            <>
               {
                  !isEmpty ?
                     <Store
                        loadingNewData={ loadingNewData }
                        activFilters={ this.filters }
                        data={ data.data }
                        isEmpty={ isEmptyByFilter }
                        isFilterFetching={ isFilterFetching }
                        onFilterChange={ this.onFilterChange }
                        searchValue={ searchValue }
                        filterType={ filterType }
                        openCloseSortModal={ this.openCloseSortModal }
                        isMobile={ screenWidth < 701 }
                        openDeleteConfirmModal={ (item) => this.openCloseDeleteModal(true, item) }
                        onMoreInfoStore={ () =>  {
                           Intercom.showArticle(ARTICLE_ID_ON_STORE);
                        } }
                        allowAddContent={ siteInfo?.can_add_content }
                        onShare={ (id, type, prefix) => {
                           this.onShare(id, type, prefix)
                           this.handleCloseModal()
                        } }
                        countesState={ isReorderMode ? { total: pinnedCount?.not_pinned_total } : countesState?.store }
                        screenWidth={ screenWidth }
                        emptyFilters={ emptyFilters }
                        onClearAllFilters={ this.onClearAllFilters }
                        categories={ categories }
                        onClickStoreCard={ () => {
                           this.filters.count = data?.data?.length || 20
                           saveStoreScrollPositionAndFilters({ scrollPosition: window.scrollY, filters: this.generateQuery(true), filtersObject: this.filters })
                        } }
                        isReorderMode={ isReorderMode }
                        setReorderMode={ () => this.onStatusFilter(isReorderMode) }
                        onSortEnd={ this.onSortEnd }
                        onClickPreview={ () => {
                           loginAs({ id: null, type: 'guest' }, siteInfo.site_url, 'store')
                        } }
                        pinning={ this.pinningBundleItem }
                        goTo={ this.onRouteChange }
                        isDemoMode={ siteInfo?.site_status === 'demo_mode' }
                        updateStoreList={ updateStoreList }
                        isInsideModal={ isInsideModal }
                        selections={ selections }
                        onSelectItem={ onSelectItem }
                        endList={ data.current_page === data.last_page }
                     />
                     :
                     <div
                        className='flex h-full items-center'
                        style={ { height: 'calc(100vh - 106px)' } }
                     >
                        <EmptyState
                           newImageSvg={ emptyStateSvg }
                           noContentText='You don’t have any store items'
                           iconColor='placeholder'
                           buttonText={ siteInfo?.can_add_content ? 'Add new store item' : null }
                           className='h-full '
                           linkButtonText='More info on the store'
                           linkButtonIcon='attention-outline'
                           overrideLinkButtonProps={ {
                              ...moreInfoProps(),
                           } }
                           onLinkClick={ () =>  {
                              Intercom.showArticle(ARTICLE_ID_ON_STORE);
                           } }
                           onAdd={ () => this.onRouteChange('STORE_ADD_NEW') }
                           titleContentText='Start by clicking on “Add new store item”'
                           svgClassName='sm:!mt-[30vh]'
                           storeButtonClasses={ true }
                           thirdButtonText='Create a bundle'
                           thirdButtonTextAction={ () => goTo(Router.route('STORE_CREATE_BUNDLE').getCompiledPath()) }
                           dontAddIntercomClassName
                           buttonDisabled={ siteInfo?.site_status === 'demo_mode' }
                        />
                     </div>
               }
               {
                  openDeleteModal.isOpen &&
                     <DeleteModal
                        name={ openDeleteModal.item.name }
                        deleteStoreMember={ this.deleteItem }
                        onCloseModal={ () => this.openCloseDeleteModal(false, null) }
                        buttonLoading={ openDeleteModal.loading }
                     />
               }
               {
                  showLinks &&
                  <Modal
                     contentPosition={ screenWidth < 430  ? 'bottom' : 'center' }
                     onClose={ () => this.handleCloseModal() }
                     otherclassName='h-84 overflow-hidden'
                     contentWidth={ screenWidth < 430  ? '100%' : '348px' }
                  >
                     <SocialMediaShareLinks
                        onClick={ () => this.handleCloseModal() }
                        onCopy={ () => this.onShareStore(shareableItemId, shareableItemType) }
                        id={ shareableItemId }
                        type={ shareableItemType }
                        locationPathPrefix={ locationPath }
                     />
                  </Modal>
               }
               {
                  confirmModal.isOpen &&
                  <ConfirmModal
                     title='Publication date change'
                     type='confirm'
                     icon='warning'
                     iconColor='warning'
                     description='Reordering has the effect of changing the publication date of content that is being reordered. Are you sure you want to reorder content?'
                     contentWidth='375px'
                     buttonText='Yes, I want to reorder content'
                     action={ () => this.onSortEnd({ newData: this.state.reorderedData.newData, newIndex: this.state.reorderedData.newIndex }, true) }
                     cancelButtonAction={ () => {
                        updateContentMetaInfo({
                           ...contentMetaInfo,
                           dont_show_content_reorder_message_store: false,
                        })
                        this.setState({
                           ...this.state,
                           confirmModal: {
                              isOpen: false,
                              checked: false,
                           },
                           reorderedData: {
                              newData: [],
                              newIndex: null,
                           },
                        })
                     } }
                     isPreventDeafault={ false }
                     isMobile={ screenWidth < 700 }
                  >
                     <div className='w-full mt-8 flex items-center justify-center'>
                        <CheckboxLabel
                           name='dont_show_message_again'
                           checked={ contentMetaInfo?.dont_show_content_reorder_message_store }
                           className='flex justify-center'
                           textColor='secondary'
                           label='Don’t show again'
                           onChange={ () => {
                              updateContentMetaInfo({
                                 ...contentMetaInfo,
                                 dont_show_content_reorder_message_store: !contentMetaInfo?.dont_show_content_reorder_message_store,
                              })
                           } }
                           padding='0'
                        />
                     </div>
                  </ConfirmModal>
               }
               {
                  warningModal?.isOpen &&
                  <ConfirmModal
                     onCloseModal={ _ => {
                        // this.onCloseOrOpenWarningModal({ isOpen: false })
                     }
                     }
                     isCloseAction
                     type='confirm'
                     icon='warning'
                     withoutCloseButton
                     iconColor='warning'
                     title={ warningModal.title }
                     description={ warningModal?.description }
                     cancelText={ warningModal.cancelText }
                     buttonText={ warningModal.buttonText }
                     secondaryButtonClassName={ warningModal.secondaryButtonClassName }
                     buttonClassName='mt-8'
                     action={ () => this.onCloseOrOpenWarningModal({ isOpen: false }) }
                     iconSize='2xl'
                     isMobile={ screenWidth < 701 }
                  />
               }
            </>

         )
      )
   }
}

const mapStateToProps = state => ({
   data: storeSelector(state),
   loading: fetchingSelector(state),
   loadingNewData: newFetchingSelector(state),
   isEmptyByFilter: isEmptyByFilterSelector(state),
   isEmpty: isEmptySelector(state),
   openDeleteModal: openDeleteModalSelector(state),
   screenWidth: screenWidthSelector(state),
   isFilterFetching: isFilterFetchingSelector(state),
   siteInfo: siteInfoSelector(state),
   countesState: countesStateSelector(state),
   categories: storeCategoriesSelector(state),
   isInited: isInitedStoreSelector(state),
   scrollPositonAndFilters: storeScrollPositionAndFiltersSelector(state),
   contentMetaInfo: contentMetaInfoSelector(state),
});

const mapDispatchToProps = dispatch => ({
   fetchData: (filter, isInsideModal, isReorderMode) => dispatch(fetchDetails(filter, false, isInsideModal, isReorderMode)),
   getNewStore: (page, isReorderMode) => dispatch(fetchNewDetails(page, isReorderMode)),
   getFilterStore: (filter, isReorderMode) => dispatch(fetchFilterDetails(filter, isReorderMode)),
   getStoreById: id => dispatch(fetchDetailsById(id)),
   setDeleteModal: data => dispatch(setDeleteModal(data)),
   deleteStore: (id, name, param, product_type, callBack) => dispatch(deleteStore(id, name, false, param, product_type, callBack)),
   goTo: (path) => {
      dispatch(push({
         pathname: path,
      }))
   },
   fetchCountsState: (query) => {
      dispatch(fetchMediaCountsStateOperation('store', query));
   },
   initCategories: () => dispatch(initCategoriesOperation()),
   saveStoreScrollPositionAndFilters: data => dispatch(saveStoreScrollPositionAndFilters(data)),
   pinOrUnpin: (data) => dispatch(pinOrUnpinBundleItems(data)),
   reorderStore: data => dispatch(reorderStore(data)),
   updateContentMetaInfo: info => dispatch(contentMetaInfo(info)),
   loginAs: (data, url, pageUrl) => {
      dispatch(loginAsOperation(data, url, pageUrl));
   },
   changeInitedState: (bool) => dispatch(changeInitedState(bool)),
   updateStoreList: (data) => dispatch(updateStoreList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreContainer);
